import React, { useState, useEffect } from 'react';
import validator from 'validator';
import axios from 'axios';
import { defaultVariables } from '../../../../config/index';
import { connect } from "trim-redux";
import {Alert, Box, Card, Checkbox, FormControlLabel, InputAdornment, MenuItem, Typography} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../../components/elements/LoadingButton";
import { Styles } from '../../../../config/design/styles';
import {useSnackbar} from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import {useNavigate} from "react-router-dom";
import FieldCounter from "../../../components/elements/fields/FieldCounter";
import SubTitle from "../../../components/elements/SubTitle";
import {useParams} from "react-router";
import {useTranslation} from "react-i18next";
import RayaField from "../../../components/elements/fields/RayaField";
import RichEditor from "../../../components/editor/RichEditor";
import EditableJsonComponent from "../../../components/elements/fields/EditJsonField";
import {
    calcInstallmentPrice,
    calcPrePayPrice,
    calcStockPrice,
    currencySymbol,
    price,
    scrollTop
} from "../../../../config/values";
import UploadPrivateFile from "../../fileManager/Components/UploadPrivateFile";
import SystemBankInfo from "../../../components/elements/SystemBankInfo";
import ContractButton from "../../../components/elements/ContractButton";
import Button from "@mui/material/Button";
import {isAdmin} from "../../../../config/Permissions";
import NumberField from "../../../components/elements/fields/NumberField";

const MakeBSRequest = (props) => {
    const { classes } = props;
    const navigation = useNavigate();
    const { t } = useTranslation();

    let { id } = useParams();

    const [fields, setFields] = useState({
        type: 'buy',
        stock_type: 'normal',
        is_installmental: 0,
        is_complete: 1,
        number_of_stocks: 1,
        description: '',
        status: '',
        buyer_name: '',
        buyer_mobile: '',
        has_buyer: 0,
        sale_price: '',

    });

    const [transactionFile, setTransactionFile] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [confirmed, setConfirmed] = useState(!!id);

    const { enqueueSnackbar } = useSnackbar();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/bs-requests/get/${id}`,config)
            .then(response => {
                setFields({
                    type: response.data.type,
                    stock_type: response.data.stock_type,
                    is_installmental:  response.data.is_installmental,
                    is_complete:  response.data.is_complete,
                    number_of_stocks: response.data.number_of_stocks,
                    description: !!response.data.description ? response.data.description : "",
                    status: response.data.status,
                    has_buyer: response.data.has_buyer,
                    buyer_name: response.data.buyer_name,
                    buyer_mobile: response.data.buyer_mobile,
                    sale_price: response.data.sale_price,
                });
                setTransactionFile(response.data.transaction_file)
                setPage(response.data)
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        if(!!id){
            loadData();
            setEditMode(true);
        }else{
            setLoading(false);

        }
        scrollTop();
    }, [id]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleInputChange = (fieldName, value) => {
        setFields((prevFields) => ({
            ...prevFields,
            [fieldName]: value,
        }));
    };
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};
        if (!fields.number_of_stocks) {
            formIsValid = false;
            newErrors.number_of_stocks = t('emptyField');
        }
        if(fields.type === "buy"){
            if (!transactionFile) {
                formIsValid = false;
                newErrors.transactionFile = t('pleaseUploadAFile');
            }
        }
        if(fields.type === "sell"){
            if(!!fields.has_buyer){
                if (!fields.buyer_name) {
                    formIsValid = false;
                    newErrors.buyer_name = t('emptyField');
                }
                if (!fields.buyer_mobile) {
                    formIsValid = false;
                    newErrors.buyer_mobile = t('emptyField');
                }
            }
        }

        if(!confirmed){
            formIsValid = false;
            newErrors['confirmed'] = t('setContractError');
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('type', fields.type);
        data.append('stock_type', fields.stock_type);

        data.append('number_of_stocks', fields.number_of_stocks);
        data.append('description', fields.description);
        data.append('is_complete', !!fields.is_complete ? 1 : 0);

        if(fields.type === "buy"){
            data.append('is_installmental', !!fields.is_installmental ? 1 : 0);
            data.append('transaction_file', !!transactionFile ? transactionFile.id : '');
        }
        if(fields.type === "sell"){
            data.append('buyer_name', fields.buyer_name);
            data.append('buyer_mobile', fields.buyer_mobile);
            data.append('has_buyer', !!fields.has_buyer ? 1 : 0);
            data.append('sale_price', fields.sale_price);
        }

        if(!!id){
            data.append('item_id', id);
        }
        if(!!isAdmin()){
            data.append('status', fields.status);

        }
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            await axios.post(`${defaultVariables.url}/bs-requests/make`, data, config);
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setSubmitLoading(false);
            navigation(`/bs-requests/view-all`);

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 422){
                enqueueSnackbar(t('stockNumberError'), { variant: 'warning' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
            }


        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };

    if (loading) {
        return <AppCardLoaderFields />;
    }
    const savedLang = localStorage.getItem('language') || 'tr';
    return (
        <Grid container spacing={2} justify="center" >
            <CssBaseline />
            {
                !!id &&
                <>
                    <Grid item size={12}>
                        <Alert
                            className="mt-20 mb-10"
                            severity={fields.status === "pending" ? "warning" : fields.status === "confirmed" ? "success" : "error"}
                        >
                            {
                                fields.status === "confirmed" ?
                                    t('yourRequestInfoConfirmed')
                                    :
                                    fields.status === "pending" ?
                                        t('yourRequestInfoIsPending')
                                        :
                                        t('yourRequestInfoIsRejected')
                            }
                        </Alert>
                    </Grid>
                    <Grid item size={12}>
                        <Typography>{t('bsNumber')}: <strong>{page.number}</strong></Typography>
                    </Grid>
                </>

            }
            <Grid item size={{xs:12,md:12}} className="bg-gray-box pt-30">
                <Grid container spacing={2} justify="center">
                    <Grid item size={{xs:12,md:6}}>
                        <RayaField
                            variant="outlined"
                            required
                            fullWidth
                            label={t('requestType')}
                            name="type"
                            value={fields.type}
                            onChange={handleChange}
                            error={!!errors.type}
                            helperText={errors.type}
                            disabled={!!id}
                            select
                        >
                            <MenuItem value="buy">{t('buy')}</MenuItem>
                            <MenuItem value="sell">{t('sell')}</MenuItem>
                        </RayaField>
                    </Grid>
                    <Grid item size={{xs:12,md:6}}>
                        <RayaField
                            variant="outlined"
                            required
                            fullWidth
                            label={t('stock_type')}
                            name="stock_type"
                            value={fields.stock_type}
                            onChange={handleChange}
                            error={!!errors.stock_type}
                            disabled={!!id}
                            helperText={errors.stock_type}
                            select
                        >
                            <MenuItem value="normal">{t('normalStock')}</MenuItem>
                            <MenuItem value="special">{t('specialStock')}</MenuItem>
                        </RayaField>
                    </Grid>
                    <Grid item size={{xs:12,md:6}}>
                        <RayaField
                            variant="outlined"
                            required
                            fullWidth
                            label={t('number_of_stocks')}
                            name="number_of_stocks"
                            value={fields.number_of_stocks}
                            onChange={handleChange}
                            disabled={!!id}
                            error={!!errors.number_of_stocks}
                            helperText={errors.number_of_stocks}
                            select
                        >
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                            <MenuItem value={4}>4</MenuItem>
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={6}>6</MenuItem>
                            <MenuItem value={7}>7</MenuItem>
                            <MenuItem value={8}>8</MenuItem>
                            <MenuItem value={9}>9</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                        </RayaField>
                    </Grid>
                    <Grid item size={{xs:12,md:6}}>
                        <RayaField
                            variant="outlined"
                            required
                            fullWidth
                            label={t('is_complete')}
                            name="is_complete"
                            value={fields.is_complete}
                            disabled={!!id}
                            onChange={handleChange}
                            error={!!errors.is_complete}
                            helperText={errors.is_complete}
                            select
                        >
                            <MenuItem value={1}>{t('yesComplete')}</MenuItem>
                            <MenuItem value={0}>{t('noComplete')}</MenuItem>
                        </RayaField>
                    </Grid>
                    {
                        fields.type === "buy" &&
                        <>
                            <Grid item size={{xs:12,md:6}}>
                                <RayaField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label={t('is_installmental')}
                                    name="is_installmental"
                                    value={fields.is_installmental}
                                    disabled={!!id}
                                    onChange={handleChange}
                                    error={!!errors.is_installmental}
                                    helperText={errors.is_installmental}
                                    select
                                >
                                    <MenuItem value={0}>{t('no')}</MenuItem>
                                    <MenuItem value={1}>{t('yes')}</MenuItem>
                                </RayaField>
                            </Grid>
                            {
                                !!id ?
                                    <Grid item size={12}>
                                        {
                                            !!fields.is_installmental  ?
                                                <Typography>
                                                    {t('prePay')}: {price(calcPrePayPrice(fields.stock_type,fields.number_of_stocks))} {currencySymbol} (40%)
                                                    <br/>
                                                    {t('installment')}: {price(calcInstallmentPrice(fields.stock_type,fields.number_of_stocks))} {currencySymbol} (5%)
                                                </Typography>
                                                :
                                                <Typography>
                                                    {t('totalPrice')}: {price(page.total_price)} {currencySymbol}
                                                    {/*<br/>
                                     {t('paidPrice')}: {price(page.paid_price)} {currencySymbol}*/}
                                                </Typography>
                                        }
                                    </Grid>
                                    :
                                    <>
                                        <Grid item size={{xs:12}}>
                                            <Box className="bg-red-box flex-space flex-column-md justify-md-center align-items-md-center">
                                                <SubTitle>{t('currentPriceBasedOnThis')}</SubTitle>
                                                {
                                                    !!fields.is_installmental ?
                                                        <Typography>
                                                            {t('prePay')}: {price(calcPrePayPrice(fields.stock_type,fields.number_of_stocks,fields.is_complete))} {currencySymbol} (40%)
                                                            <br/>
                                                            {t('installment')}: {price(calcInstallmentPrice(fields.stock_type,fields.number_of_stocks,fields.is_complete))} {currencySymbol} (5%)
                                                        </Typography>
                                                        :
                                                        <strong style={{fontSize:16}}>
                                                            {price(calcStockPrice(fields.stock_type,fields.number_of_stocks,fields.is_complete))} {currencySymbol}
                                                        </strong>
                                                }
                                            </Box>
                                        </Grid>
                                        <Grid item size={12}>
                                            <SystemBankInfo/>
                                        </Grid>
                                    </>
                            }
                            <Grid item size={12}>
                                <SubTitle align="left">{t('submitTransactionFile')}</SubTitle>
                                <UploadPrivateFile
                                    title={t('uploadTransactionFile')}
                                    setFile={(file) => setTransactionFile(file)}
                                    init={transactionFile}
                                />
                                {
                                    !!errors['transactionFile'] &&
                                    <Typography className="error-text">{errors['transactionFile']}</Typography>
                                }
                            </Grid>
                        </>

                    }
                    {
                        fields.type === "sell" &&
                        <>
                            <Grid item size={{xs:12,md:6}}>
                                <NumberField
                                    fullWidth
                                    label={t('salePrice')}
                                    variant="outlined"
                                    value={fields.sale_price}
                                    endAdornment={currencySymbol}
                                    decimals={2}
                                    min={0}
                                    onChange={(res) => handleInputChange('sale_price',res)}
                                    error={!!errors.sale_price}
                                    helperText={!!errors.sale_price ? errors.sale_price : t('salePriceDesc')}
                                />
                            </Grid>
                            <Grid item size={{xs:12,md:6}}>
                                <RayaField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label={t('hasBuyer')}
                                    name="has_buyer"
                                    value={fields.has_buyer}
                                    disabled={!!id}
                                    onChange={handleChange}
                                    error={!!errors.has_buyer}
                                    helperText={errors.has_buyer}
                                    select
                                >
                                    <MenuItem value={0}>{t('no')}</MenuItem>
                                    <MenuItem value={1}>{t('yes')}</MenuItem>
                                </RayaField>
                            </Grid>
                            {
                                !!fields.has_buyer &&
                                <>

                                    <Grid item size={{xs:12,md:6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('buyer_name')}
                                            name="buyer_name"
                                            value={fields.buyer_name}
                                            onChange={handleChange}
                                            error={!!errors.buyer_name}
                                            helperText={errors.buyer_name}
                                        />
                                    </Grid>
                                    <Grid item size={{xs:12,md:6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('buyer_mobile')}
                                            name="buybuyer_mobileer_name"
                                            value={fields.buyer_mobile}
                                            onChange={handleChange}
                                            error={!!errors.buyer_mobile}
                                            helperText={errors.buyer_mobile}
                                        />
                                    </Grid>
                                </>
                            }

                        </>
                    }
                    <Grid item size={{xs:12}}>
                        <RayaField
                            variant="outlined"
                            required
                            fullWidth
                            label={t('description')}
                            name="description"
                            value={fields.description}
                            onChange={handleChange}
                            error={!!errors.description}
                            helperText={errors.description}
                            multiline
                        />
                    </Grid>
                    {
                        !isAdmin() &&
                        <Grid item size={{ xs: 12 }}>
                            <FormControlLabel
                                label={
                                    <Typography>{t('setContract')} <ContractButton/> {t('setContract3')}</Typography>
                                }
                                disabled={!!id}
                                control={<Checkbox checked={confirmed} onChange={() => setConfirmed(!confirmed)} />}
                            />
                            <Button
                                color="secondary"
                                size="small"
                                component="a"
                                href={`${defaultVariables.uploads}/${savedLang}_contract.pdf`}
                                target="_blank"

                            >
                                {t('downloadContract')}
                            </Button>
                            {
                                !!errors['confirmed'] &&
                                <Typography className="error-text">{errors['confirmed']}</Typography>
                            }
                        </Grid>
                    }

                    {
                        !!isAdmin() &&
                        <Grid item size={{xs:12,md:6}}>
                            <RayaField
                                variant="outlined"
                                required
                                fullWidth
                                label={t('status')}
                                name="status"
                                value={fields.status}
                                onChange={handleChange}
                                error={!!errors.status}
                                helperText={errors.status}
                                select
                            >
                                <MenuItem value='rejected'>{t('rejected')}</MenuItem>
                                <MenuItem value='pending'>{t('pending')}</MenuItem>
                                <MenuItem value='confirmed'>{t('confirmed')}</MenuItem>
                            </RayaField>
                            {
                                fields.status === "confirmed" &&
                                <>
                                    <Typography style={{marginTop:10}}>{t('adminHintBS')}</Typography>
                                    {
                                        (!!fields.is_installmental) &&
                                        <Typography color="primary" style={{marginTop:10}}>{t('adminHintBSInstallment')}</Typography>
                                    }
                                </>
                            }
                        </Grid>
                    }
                    <Grid item size={12}>
                        <LoadingButton
                            variant="contained"
                            color="secondary"
                            onClick={handleSubmit}
                            loading={submitLoading}
                        >
                            {!!id ? t('updateRequest') : t('submitRequest')}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(MakeBSRequest));
